export const AGENT_APPROVAL_POLL_INTERVAL_MS = 10000;
export const AGENT_APPROVAL_POLL_MAX_DURATION_MS = 180000;